export const KENYA_CONNECT_CATEGORIES = [
  { id: 'land',         icon: '🏞', name: 'Land & Plots',       desc: 'Buy or invest in land back home with verified listings.' },
  { id: 'livestock',    icon: '🐄', name: 'Livestock',          desc: 'Cattle, goats, poultry — buy or sell through the community.' },
  { id: 'investment',   icon: '📈', name: 'Business Investment', desc: 'Partner on businesses and ventures in Kenya.' },
  { id: 'construction', icon: '🏗', name: 'Build-for-you',      desc: 'Construction and project management while you are abroad.' },
  { id: 'insurance',    icon: '🛡', name: 'Insurance',          desc: 'Diaspora-friendly cover for family and assets in Kenya.' },
];

export const KENYA_CONNECT_GUIDES = {
  land: {
    title: 'Buying land from abroad',
    steps: [
      'Verify title deed and survey maps with a licensed advocate.',
      'Use a trusted local agent for site visits — mudiaspora agents can inspect on your behalf.',
      'Never pay full amount before a signed sale agreement and due diligence.',
      'Register the transfer at the lands office; keep copies of all receipts.',
    ],
    tips: ['Ask for recent photos and GPS pin.', 'Check county zoning before committing.'],
  },
  livestock: {
    title: 'Livestock investment',
    steps: [
      'Define breed, head count, and expected returns with the seller.',
      'Arrange a farm visit report through a mudiaspora caretaker or agent.',
      'Agree on health records and vaccination history.',
      'Set up periodic photo/video updates as part of the deal.',
    ],
    tips: ['Start small if new to livestock.', 'Use written contracts.'],
  },
  investment: {
    title: 'Business partnerships',
    steps: [
      'Review business plan and audited accounts where available.',
      'Meet partners via video and check references in the community.',
      'Structure equity or loan terms with a Kenyan lawyer.',
      'Track milestones through mudiaspora dashboard requests.',
    ],
    tips: ['Prefer businesses with existing cash flow.', 'Clarify exit terms upfront.'],
  },
  construction: {
    title: 'Building while abroad',
    steps: [
      'Get itemised BOQ (bill of quantities) from at least two contractors.',
      'Stage payments tied to verified progress photos and site reports.',
      'Use mudiaspora agents for weekly site visits and material checks.',
      'Keep all permits and NEMA approvals on file.',
    ],
    tips: ['Never pay 100% upfront.', 'Insist on milestone-based contracts.'],
  },
  insurance: {
    title: 'Insurance for diaspora families',
    steps: [
      'List who and what you need covered (life, health, property, crop).',
      'Compare diaspora desks at APA, Jubilee, Britam, and others.',
      'Confirm claims process works from Japan (documents, contacts).',
      'Review annually as family situation changes.',
    ],
    tips: ['Many insurers offer M-Pesa premium payment.', 'Keep beneficiaries updated.'],
  },
};

export const INSURANCE_PARTNERS = [
  { name: 'APA Insurance', note: 'Diaspora life & medical cover' },
  { name: 'Jubilee Insurance', note: 'Life, health, and asset policies' },
  { name: 'Britam', note: 'General and life insurance' },
  { name: 'CIC Insurance', note: 'Agri and SME cover' },
];

export const POPULAR_KENYA_COUNTIES = [
  'Nairobi', 'Kiambu', 'Nakuru', 'Kisumu', 'Mombasa', 'Uasin Gishu',
  'Kericho', 'Nyeri', 'Machakos', 'Kajiado', 'Meru', 'Kakamega',
];
